import { ref } from 'vue';

export const formatDateForDisplay = (dateString) => {
    if (!dateString) return 'N/A';
    const [year, month, day] = dateString.split('-');
    if (!year || !month || !day) return dateString;
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' });
};

export const formatCurrency = (value) => {
  if (value === null || typeof value === 'undefined') return '';
  if (typeof value !== 'number') value = parseFloat(value);
  if (isNaN(value)) return '';
  
  try {
    const { useAuthStore } = require('@/stores/auth');
    const authStore = useAuthStore();
    
    console.log('authStore.company.currency_code:', authStore.company.currency_code);
    if(authStore.company?.currency_code){
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: authStore.company.currency_code }).format(value);
    }
  } catch (error) {
    console.warn('Could not access auth store for currency formatting:', error);
  }

    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'UGX' }).format(value);
};

export const getCurrencyPrefix = () => {
  try {
    const { useAuthStore } = require('@/stores/auth');
    const authStore = useAuthStore();

    console.log('authStore.company.currency_code:', authStore.company.currency_code);
    
    if (authStore.company?.currency_code) {
      return authStore.company.currency_code;
    }
  } catch (error) {
    console.warn('Could not access auth store for currency prefix:', error);
  }
  
  return 'UGX'; // Default currency
};

export const formatDaySuffix = (day_of_month) => {
  if (!day_of_month) return 'N/A';
  const day = parseInt(day_of_month);
  if (isNaN(day)) return day_of_month;
  if (day % 10 === 1 && day !== 11) return 'st';
  if (day % 10 === 2 && day !== 12) return 'nd';
  if (day % 10 === 3 && day !== 13) return 'rd';
  return 'th';
};

const snackbar = ref({ show: false, message: '', color: 'success', timeout: 4000 });

export function useSnackbar() {
  const showSnackbar = (message, color = 'success', timeout = 4000) => {
    snackbar.value = { message, color, timeout, show: true };
  };

  return {
    snackbar,
    showSnackbar
  };
}